import { useSelector } from "react-redux";

const useActiveLanguage = () => {
  return useSelector((state) => state?.customerReducer?.language_code);
};

export default useActiveLanguage;
